import { useNotifier } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { ShowFor, Chevron } from '@utils/react';
import { HotspotContent } from './molecule.hotspot-content.js';
import { buttonList, trigger, triggerGraphic, triggerIndexBullet, triggerTitle, triggerChevron } from './molecule.mobile-buttons.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function MobileButtons(props) {
  return /*#__PURE__*/jsx(ShowFor, {
    breakpoint: breakpoints.mobile,
    children: /*#__PURE__*/jsx("ul", {
      className: buttonList,
      children: props.component.data.hotspots.map((hotspot, index) => /*#__PURE__*/jsx("li", {
        children: /*#__PURE__*/jsx(MobileButton, {
          showIndex: !!props.component.data.settings.showIndexOnHotspots,
          index: index,
          hotspot: hotspot
        })
      }, hotspot.id))
    })
  });
}
function MobileButton(props) {
  const notifier = useNotifier();
  const handleClick = () => {
    notifier.modal({
      closeButtonLabel: "Luk hotspot",
      content: /*#__PURE__*/jsx(HotspotContent, {
        id: undefined,
        onClose: undefined,
        hotspot: props.hotspot
      })
    });
  };
  return /*#__PURE__*/jsxs("button", {
    className: trigger,
    "aria-label": props.hotspot.title ? `Åbn "${props.hotspot.title}"` : "Åbn hotspot",
    onClick: handleClick,
    children: [props.hotspot.hotspotGraphicsURL ? /*#__PURE__*/jsxs("span", {
      className: triggerGraphic,
      children: [/*#__PURE__*/jsx("img", {
        src: props.hotspot.hotspotGraphicsURL,
        alt: "",
        role: "presentation"
      }), props.showIndex && /*#__PURE__*/jsx("span", {
        className: triggerIndexBullet,
        children: props.index + 1
      })]
    }) : props.showIndex && /*#__PURE__*/jsx("span", {
      className: triggerIndexBullet,
      children: props.index + 1
    }), /*#__PURE__*/jsx("span", {
      className: triggerTitle,
      children: props.hotspot.title
    }), /*#__PURE__*/jsx(Chevron, {
      className: triggerChevron,
      size: 9,
      lineWidth: 1.5
    })]
  });
}

export { MobileButtons };
//# sourceMappingURL=molecule.mobile-buttons.js.map
